module.exports = __webpack_public_path__ + "static/media/logo.34e3e1a8.png";